export default __webpack_public_path__ + "static/media/logo.fc197fc0.png";